<script lang="ts">
  import {onMount} from 'svelte';
  import editorStore from '../../../../lib/editor/editor.store';
  import editorInstance from '../../../../lib/editor/editor';
  import {thumbnail} from '@/store';

  export let primary: boolean = false;
  let fontNode: HTMLElement | null = null;
  let textAIString: string = '';

  function getAITextEl(): HTMLElement | null {
    if ($thumbnail.type === 'quote') {
      return document.querySelector('[data-amelement="quote"]');
    } else if ($thumbnail.type === 'thumbnail') {
      return document.querySelector('[data-amelement="title"]');
    }
    return document.querySelector('[data-amelement="quote"]');
  }

  function openTextAI() {
    console.log(getAITextEl());
    editorStore.setActiveComponent(getAITextEl());
  }

  function onMouseOver() {
    // Get all elements on page with the font variable being the fontFamily
    const el = getAITextEl();
    if (el) editorInstance.ui.highlight(el);
  }
  function onMouseLeave() {
    editorInstance.ui.removeHighlight();
  }

  function trunc(str: string) {
    if (str.length > 30) {
      return str.slice(0, 27) + '...';
    }
    return str;
  }

  onMount(() => {
    // textAIElementsStore.subscribe((elements) => {
    //    if (elements.length > 0) {
    //       textAIString = elements[0].innerText;
    //    }
    // });
    thumbnail.subscribe(project => {
      if (project.type === 'quote' && project.quote) {
        textAIString = project.quote;
      } else if (project.type === 'thumbnail' && project.title) {
        textAIString = project.title;
      }
    });
  });
</script>

<div
  class="flex w-full flex-row items-center justify-between gap-2"
  on:focus={onMouseOver}
  on:mouseover={onMouseOver}
  on:mouseleave={onMouseLeave}
>
  <div class="label flex text-sm" id="genText">
    Generated {$thumbnail.type === 'quote' ? 'Quotes' : 'Titles'}
    <i class="fa-solid fa-wand-magic-sparkles text-primary"></i>
  </div>
  <button
    class="flex max-w-[190px] flex-grow items-center rounded-xl border border-zinc-300 px-4 py-3 hover:bg-zinc-200"
    on:click={openTextAI}
    on:keydown={openTextAI}
  >
    <span class="block truncate text-xs font-bold">{textAIString ? trunc(textAIString) : 'Get AI recommendations'}</span
    >
    <i class="fa fa-angle-right ml-auto block"></i>
  </button>
</div>

<style lang="postcss">
  .label {
    @apply block font-bold;
  }
</style>
